import { bbListingPreview } from './listing_preview.component';

angular
  .module('bb.listing_preview', ['bb.listing', 'bb.appointments'])
  .component('bbListingPreview', bbListingPreview);

require('./listing_preview.component');
require('./preview_button.component');
require('./preview_modal.component');
require('./network_modal.component');
